import React, { createContext, useState, useContext } from 'react';

const TabStateContext = createContext(undefined);

export const useTabState = () => 
{
    const context = useContext(TabStateContext);
    if (context === undefined) 
    {
        throw new Error('useTabState must be used within a TabStateProvider');
    }
    return context;
};

export const TabStateProvider = ({ children }) =>
{
    const [tabStates, setTabStates] = useState(new Map());

    const setTabState = (componentId, tabIndex, totalTabs = null) =>
    {
        setTabStates(prev => 
        {
            const newMap = new Map(prev);
            newMap.set(componentId, tabIndex);
            return newMap;
        });
    };

    const getTabState = (componentId, totalTabs = null, defaultValue = 0) =>
    {
        const savedState = tabStates.get(componentId);
        if (savedState === undefined) 
        {
            return defaultValue;
        }
        return savedState;
    };

    const value = 
    {
        setTabState,
        getTabState
    };

    return (
        <TabStateContext.Provider value={value}>
            {children}
        </TabStateContext.Provider>
    );
};